import styled from 'styled-components';
import { mqLargeMin } from 'styled/tools/media-queries';

export const SiteAsideStyled = styled.div`
  position: relative;
  width: 100%;

  @media ${mqLargeMin} {
    position: absolute;
    left: 0;
    top: 0;
  }

  .head {
    .title {
      * {
        font-size: var(--font-size-400);
        text-decoration: none;
        font-weight: 500;
        line-height: 1.5;
      }
    }

    .subtitle {
      * {
        font-size: var(--font-size-350);
        font-weight: 500;
      }
    }
  }

  .head {
    .title {
      * {
        text-transform: capitalize;
      }
    }
  }

  .body {
    @media ${mqLargeMin} {
      margin-top: 40px;
    }
  }

  .foot {
    display: none;
    margin-top: 33px;

    @media ${mqLargeMin} {
      display: block;
    }
  }
`;
